const INITIAL_STATE = {
    data: null
}

const DadosProfissionalReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'dadosprofissional': {

            return {
                ...state,
                data: action.payload.dadosprofissional
            }
        }
        default: {
            return state
        }
    }
}

export default DadosProfissionalReducer